import CONSTANTS from "../../../const/constants";

/**
 * Regla única de acceso al Análisis de plantillas, compartida por la ruta
 * `/plantillas`, la pestaña de Analíticas y el nav. Ven el panel:
 * - Cualquier usuario de la compañía Mobieffects, o
 * - Superadmins de compañías con `isTemplateAnalysisEnabled`.
 */
export function canSeeTemplateAnalysis(userData) {
  if (!userData) return false;
  const companyId = userData?.company?.id;
  const isTemplateAnalysisEnabled = userData?.company?.isTemplateAnalysisEnabled;
  const isSuperadmin = userData?.rol?.name === CONSTANTS.SUPERADMIN;
  return (
    companyId === CONSTANTS.MOBIEFFECTS_COMPANY_ID ||
    (Boolean(isTemplateAnalysisEnabled) && isSuperadmin)
  );
}
